<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link to="/">{{$t('privacyProvider.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">
          {{$t('privacyProvider.breadcrumb_2')}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row pt-4 privacyProvider">
          <div class="col-12">
            <h6>{{$t('privacyProvider.lastUpdated')}}</h6>
            <p>{{$t('privacyProvider.aqarAlmuhaysini_provider_App')}}</p>
            <h6 class="almarai-bold">{{$t('privacyProvider.byUsing_App')}}</h6>
            <h6 class="almarai-bold">{{$t('privacyProvider.Information_WeCollect')}}</h6>
            <ul>
              <li>
                <span class="almarai-bold">{{$t('privacyProvider.personalInformation')}}</span>
                <h6>{{$t('privacyProvider.followingInformation')}}</h6>
                <ul>
                  <li>{{$t('privacyProvider.fullName')}}</li>
                  <li>{{$t('privacyProvider.mobileNumber')}}</li>
                  <li>{{$t('privacyProvider.emailAddress')}}</li>
                  <li>{{$t('privacyProvider.nationalID')}}</li>
                  <li>{{$t('privacyProvider.profilePicture')}}</li>
                  <li>{{$t('privacyProvider.bankAccount_Details')}}</li>
                </ul>
              </li>
              <li>
                <span class="almarai-bold">{{$t('privacyProvider.serviceProvider_Information')}}</span>
                <ul>
                  <li>{{$t('privacyProvider.typeService')}}</li>
                  <li>{{$t('privacyProvider.scopeWork')}}</li>
                  <li>{{$t('privacyProvider.availabilityTimes')}}</li>
                  <li>{{$t('privacyProvider.offersPrices')}}</li>
                  <li>{{$t('privacyProvider.historyCompleted')}}</li>
                </ul>
              </li>
              <li>
                <span class="almarai-bold">{{$t('privacyProvider.locationInformation')}}</span>
                <h6>{{$t('privacyProvider.providerLocation')}}</h6>
                <ul>
                  <li>{{$t('privacyProvider.duringOrder')}}</li>
                  <li>{{$t('privacyProvider.propertyLocation')}}</li>
                </ul>
                <h6>{{$t('privacyProvider.locationTracking')}}</h6>
              </li>
              <li>
                <span class="almarai-bold">{{$t('privacyProvider.technicalInformation')}}</span>
                <ul>
                  <li>{{$t('privacyProvider.deviceType')}}</li>
                  <li>{{$t('privacyProvider.internetProtocol')}}</li>
                  <li>{{$t('privacyProvider.usageData')}}</li>
                  <li>{{$t('privacyProvider.performanceImprovement')}}</li>
                </ul>
              </li>
            </ul>

            <h6 class="almarai-bold">{{$t('privacyProvider.howInformation')}}</h6>
            <p>{{$t('privacyProvider.collectedInformation')}}</p>
            <ul>
              <li>{{$t('privacyProvider.operating_TheApplication')}}</li>
              <li>{{$t('privacyProvider.connectingProviders')}}</li>
              <li>{{$t('privacyProvider.organizingScheduling')}}</li>
              <li>{{$t('privacyProvider.Communicating')}}</li>
              <li>{{$t('privacyProvider.verifyingIdentity')}}</li>
              <li>{{$t('privacyProvider.processingPayments')}}</li>
              <li>{{$t('privacyProvider.improvingService')}}</li>
              <li>{{$t('privacyProvider.Complying')}}</li>
            </ul>
            <!-- begin:Third_SharingInformation -->
            <h6 class="almarai-bold">{{$t('privacyProvider.Third_SharingInformation')}}</h6>
            <p>{{$t('privacyProvider.Almuhaysini_Provider_application')}}</p>
            <h6>{{$t('privacyProvider.data_maybe_Shared')}}</h6>
            <ul>
              <li>{{$t('privacyProvider.clients')}}</li>
              <li>{{$t('privacyProvider.electronic')}}</li>
              <li>{{$t('privacyProvider.technicalPartners')}}</li>
              <li>{{$t('privacyProvider.governmentEntities')}}</li>
            </ul>
            <h6>{{$t('privacyProvider.Sharing')}}</h6>
            <!-- end:Third_SharingInformation -->

            <!-- begin:Fourth Information Protection -->
            <h6 class="almarai-bold">{{$t('privacyProvider.Fourth_InformationProtection')}}</h6>
            <p>{{$t('privacyProvider.committedTaking')}}</p>
            <ul>
              <li>{{$t('privacyProvider.dataEncryption')}}</li>
              <li>{{$t('privacyProvider.systemsPrevent')}}</li>
              <li>{{$t('privacyProvider.restrictingAccess')}}</li>
            </ul>
            <h6>{{$t('privacyProvider.acknowledges')}}</h6>
            <!-- end:Fourth Information Protection -->

            <!-- begin:Fifth Data Retention -->
            <h6 class="almarai-bold">{{$t('privacyProvider.Fifth_DataRetention')}}</h6>
            <p>{{$t('privacyProvider.dataRetained')}}</p>
            <!-- end:Fifth Data Retention -->

            <!-- begin: Sixth Service Provider -->
            <h6 class="almarai-bold">{{$t('privacyProvider.Sixth_ServiceProvider')}}</h6>
            <p>{{$t('privacyProvider.serviceProvider')}}</p>
            <ul>
              <li>{{$t('privacyProvider.personalData')}}</li>
              <li>{{$t('privacyProvider.update_Accountinformation')}}</li>
              <li>{{$t('privacyProvider.requestAccount')}}</li>
              <li>{{$t('privacyProvider.revoke_Certainprivileges')}}</li>
            </ul>
            <h6>{{$t('privacyProvider.applicationAdministration')}}</h6>
            <!-- end: Sixth Service Provider -->

            <!-- begin:Seventh CookiesSimilar_Technologies -->
            <h6 class="almarai-bold">{{$t('privacyProvider.Seventh_CookiesSimilar_Technologies')}}</h6>
            <p>{{$t('privacyProvider.analytical_Technologiesimprove')}}</p>
            <!-- end:Seventh CookiesSimilar_Technologies -->

            <!-- begin:Eighth Privacy of minors -->
            <h6 class="almarai-bold">{{$t('privacyProvider.privacyPolicy')}}</h6>
            <p>{{$t('privacyProvider.application_Notintended')}}</p>
            <!-- end:Eighth Privacy of minors -->

            <!-- begin:Ninth Amendments to the Privacy Policy -->
            <h6 class="almarai-bold">{{$t('privacyProvider.amendments_PrivacyPolicy')}}</h6>
            <p>{{$t('privacyProvider.amend_PrivacyPolicy')}}</p>
            <h6>{{$t('privacyProvider.application_Afteramendments')}}</h6>
            <!-- end:Ninth Amendments to the Privacy Policy -->

            <!-- begin:Tenth Contacting us -->
            <h6 class="almarai-bold">{{$t('privacyProvider.tenth_Contactingus')}}</h6>
            <p>{{$t('privacyProvider.pleaseContactus')}}</p>
            <ul>
              <li class="almarai-bold">{{$t('privacyProvider.email')}}: (info@amaqaria.com)</li>
              <li class="almarai-bold">{{$t('privacyProvider.phoneNumber')}}</li>
            </ul>
            <!-- end:Tenth Contacting us -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "privacyProvider",
  data(){
    return{
      userLang: "ar",
    }
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>